module.exports = __webpack_public_path__ + "img/checkmark-icon.b1e18fb9.svg";